import React, { Component, useEffect } from 'react';
import axios from 'axios';
import { API_HOST } from '../../consts';
import { Form } from 'informed';
import SimpleBarChart from './SimpleBarChart';
import SimpleTable from './SimpleTable';
import SkillsList from './DataComponente';
import { Grid } from '@material-ui/core';
import { withTheme } from 'styled-components';
import {
  Description as DescriptionIcon,
  PictureAsPdfRounded as PictureAsPdfIcon
} from '@material-ui/icons';
import BarChartHorizontal from './BarChartHorizontal';
import { toast } from 'react-toastify';
import html2pdf from 'html2pdf.js';
import * as XLSX from 'xlsx';
import ClassPlanCard from '../../components/pae/ClassPlanCard';
import Loading from '../../components/Loading';

class ReportDrePage extends Component {
  state = {
    currentPage: 1,
    itemsPerPage: 6,
    totalPages: 0,
    currentPageEscola: 1,
    itemsPerPageEscola: 12,
    dataTotal: [],
    data: [],
    dataEscolaTotal: [],
    dataEscola: [],
    tabValue: 'habilidade',
    dataDr: [],
    dataPeriodoTotal: [],
    dataPeriodo: [],
    dataComponenteTotal: [],
    dataComponente: [],
    dataMetodologiaTotal: [],
    dataMetodologia: [],
    dataPeriodoGeral: [],
    isLoading: false,
    fetchDone: false,
    isLoadingdr: false,
    fetchDonedr: false,
    isLoadingtb: false,
    fetchDonetb: false,
    isLoadingdc: false,
    fetchDonedc: false,
    selectedDepartmentType: 'national',
    selectedRegion: 'all',
    updateDate: ''
  };
  handleDepartmentTypeChange = (event) => {
    const selectedDepartmentType = event.target.value;
    this.setState({ selectedDepartmentType });
  };

  updateTotalItens = (value) => {
    let totalItems = 0

    if(value === 'habilidade'){
      totalItems = this.state.dataTotal.length;
    } else if(value === 'metodologia'){
      totalItems = this.state.dataMetodologiaTotal.length;
    } else {
      totalItems = this.state.dataPeriodoTotal.length;
    }
    const totalPages = Math.ceil(totalItems / this.state.itemsPerPage);
    this.setState({totalPages})
  }

  handleTabValue = (value) => {
    this.setState({tabValue: value, currentPage: 1}, () => {
      this.fetchDataHabilidade();
      this.fetchDataPeriodo();
      this.fetchDataMetodologia();
    });
    this.updateTotalItens(value)
  }

  handleRegionChange = (event) => {
    const selectedRegion = event.target.value;
    this.setState({ selectedRegion });
  };

  fetchUpdateDate = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/openai/date-update`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
			this.setState({ updateDate: response.data.atualizado_em });
    } catch (error) {
      console.error(error.message);
    }
  }

  fetchDataHabilidade = (searchQuery) => {
    this.setState({ isLoadingdc: true })
    const token = localStorage.getItem('token');
    const { currentPage, itemsPerPage } = this.state;

    if (token) {
      axios
        .get(`${API_HOST}/openai/habilidades-uso`)
        .then((res) => {
          let data = res.data;

          if (searchQuery) {
            data = data.filter((item) => {
              return (
                item &&
                item.habilidade_codigo &&
                item.habilidade_codigo.includes(searchQuery)
              );
            });
          }

          const startIndex = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
          const paginatedData = data.slice(startIndex, endIndex);

          this.setState({ data: paginatedData, dataTotal: data }, () => {
            if(this.state.totalPages === 0){
              this.updateTotalItens(this.state.tabValue)
            }
          });
          this.setState({ isLoadingdc: false })
          this.setState({ fetchDonedc: true })
        })
        .catch((error) => {
          console.error('Erro de autenticação:', error);
        });
    } else {
      console.error('Token de autenticação não encontrado');
    }
  };

  fetchDataUser = () => {
    axios.get(`${API_HOST}/openai/user-uso`).then((res) => {
      let data = res.data;
      this.setState({ userUso: data })
    })
  }

  fetchDataPeriodo = (searchQuery) => {
    this.setState({ isLoadingdc: true })
    const token = localStorage.getItem('token');
    const { currentPage, itemsPerPage } = this.state;

    if (token) {
      axios
        .get(`${API_HOST}/openai/periodos-uso`)
        .then((res) => {
          let data = res.data;

          if (searchQuery) {
            data = data.filter((item) => {
              return (
                item &&
                item.periodo_nome &&
                item.periodo_nome.toUpperCase().includes(searchQuery)
              );
            });
          }

          const startIndex = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
          const paginatedData = data.slice(startIndex, endIndex);

          this.setState({ dataPeriodo: paginatedData, dataPeriodoTotal: data });
          this.setState({ isLoadingdc: false })

        })
        .catch((error) => {
          console.error('Erro de autenticação:', error);
        });
    } else {
      console.error('Token de autenticação não encontrado');
    }
  };

  fetchPlanosCount = () => {
    const token = localStorage.getItem('token');

    if (token) {
      axios
        .get(`${API_HOST}/openai/uso-geral`)
        .then((res) => {
          const data = res.data;

          this.setState({ dataCount: data.numero_planos });
        })
        .catch((error) => {
          console.error('Erro de autenticação:', error);
        });
    } else {
      console.error('Token de autenticação não encontrado no localStorage');
    }
  };

  fetchDataEscola = () => {
    this.setState({ isLoadingtb: true })
    const token = localStorage.getItem('token');
    const { itemsPerPageEscola, currentPageEscola } = this.state;

    if (token) {
      axios
        .get(`${API_HOST}/openai/escolas-uso`)
        .then((res) => {
          const dataEscola = res.data;
          const totalItemsEscola = dataEscola.length;
          const totalPagesEscola = Math.ceil(
            totalItemsEscola / itemsPerPageEscola
          );

          const startIndex = (currentPageEscola - 1) * itemsPerPageEscola;
          const endIndex = startIndex + itemsPerPageEscola;
          const paginatedDataEscola = dataEscola.slice(startIndex, endIndex);

          this.setState({
            dataEscola: paginatedDataEscola,
            totalPagesEscola,
            dataEscolaTotal: dataEscola
          });
          this.setState({ isLoadingtb: false })
          this.setState({ fetchDonetb: true })
        })
        .catch((error) => {
          console.error('Erro de autenticação:', error);
        });
    } else {
      console.error('Token de autenticação não encontrado no localStorage');
    }
  };

  fetchDataDr = () => {
    this.setState({ isLoadingdr: true })
    const token = localStorage.getItem('token');

    if (token) {
      axios
        .get(`${API_HOST}/openai/dr-uso`)
        .then((res) => {
          const dataDr = res.data;

          this.setState({ dataDr: dataDr });
          this.setState({ isLoadingdr: false })
          this.setState({ fetchDonedr: true })
        })
        .catch((error) => {
          console.error('Erro de autenticação:', error);
        });
    } else {
      console.error('Token de autenticação não encontrado no localStorage');
    }
  };

  fetchDataComponente = (searchQuery) => {
    this.setState({ isLoadingdc: true })
    const token = localStorage.getItem('token');
    const { currentPage, itemsPerPage } = this.state;

    if (token) {
      axios
        .get(`${API_HOST}/openai/componente-uso`)
        .then((res) => {
          let data = res.data;

          if (searchQuery) {
            data = data.filter((item) => {
              return (
                item &&
                item.componente_curricular_nome &&
                item.componente_curricular_nome.toUpperCase().includes(searchQuery)
              );
            });
          }

          const startIndex = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
          const paginatedData = data.slice(startIndex, endIndex);

          this.setState({
            dataComponente: paginatedData,
            dataComponenteTotal: data
          });
          this.setState({ isLoadingdc: false })

        })
        .catch((error) => {
          console.error('Erro de autenticação:', error);
        });
    } else {
      console.error('Token de autenticação não encontrado no localStorage');
    }
  };

  fetchDataMetodologia = (searchQuery) => {
    this.setState({ isLoadingdc: true })

    const token = localStorage.getItem('token');
    const { currentPage, itemsPerPage } = this.state;

    if (token) {
      axios
        .get(`${API_HOST}/openai/metodologia-uso`)
        .then((res) => {
          let data = res.data;

          if (searchQuery) {
            data = data.filter((item) => {
              return (
                item &&
                item.metodologia_nome &&
                item.metodologia_nome.toUpperCase().includes(searchQuery)
              );
            });
          }

          const startIndex = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
          const paginatedData = data.slice(startIndex, endIndex);

          this.setState({
            dataMetodologia: paginatedData,
            dataMetodologiaTotal: data
          });
          this.setState({ isLoadingdc: false })

        })
        .catch((error) => {
          console.error('Erro de autenticação:', error);
        });
    } else {
      console.error('Token de autenticação não encontrado no localStorage');
    }
  };

  fetchDataPeriodoGeral = () => {
    this.setState({ isLoading: true })
    const token = localStorage.getItem('token');
    const { currentPage, itemsPerPage } = this.state;

    if (token) {
      axios
        .get(`${API_HOST}/openai/periodo-geral-uso`)
        .then((res) => {
          let data = res.data;

          const startIndex = (currentPage - 1) * itemsPerPage;
          const endIndex = startIndex + itemsPerPage;
          const paginatedData = data.slice(startIndex, endIndex);

          this.setState({ dataPeriodoGeral: paginatedData });
          this.setState({ isLoading: false })
          this.setState({ fetchDone: true })
        })
        .catch((error) => {
          console.error('Erro de autenticação:', error);
        });
    } else {
      console.error('Token de autenticação não encontrado no localStorage');
    }
  };

  componentDidMount() {
    this.fetchDataHabilidade();
    this.fetchDataEscola();
    this.fetchDataDr();
    this.fetchDataPeriodo();
    this.fetchDataComponente();
    this.fetchDataMetodologia();
    this.fetchDataPeriodoGeral();
    this.fetchDataUser();
    this.fetchPlanosCount();
    this.fetchUpdateDate();
  }

  handlePrevPage = () => {
    if (this.state.currentPage > 1) {
      const prevPage = this.state.currentPage - 1;

      this.setState({ currentPage: prevPage }, () => {
        if(this.state.tabValue === 'habilidade'){
          this.fetchDataHabilidade();
        } else if(this.state.tabValue === 'metodologia'){
          this.fetchDataMetodologia();
        } else {
          this.fetchDataPeriodo();
        }
      });
    }
  };


  handleNextPage = () => {
    const nextPage = this.state.currentPage + 1;

    this.setState({ currentPage: nextPage }, () => {
      if(this.state.tabValue === 'habilidade'){
        this.fetchDataHabilidade();
      } else if(this.state.tabValue === 'metodologia'){
        this.fetchDataMetodologia();
      } else {
        this.fetchDataPeriodo();
      }
    });
  };

  handlePrevPageEscola = () => {
    if (this.state.currentPageEscola > 1) {
      const prevPage = this.state.currentPageEscola - 1;

      this.setState({ currentPageEscola: prevPage }, () => {
        this.fetchDataEscola();
      });
    }
  };
  convertStringToJSONArray = (inputString) => {
    let jsonString = inputString.replace(/‘|’/g, "'");
    jsonString = jsonString.replace(/'/g, '"');
    jsonString = jsonString.replace(/,\s*(?=})/g, '');
    jsonString = jsonString.replace(/"medio":\s*True/g, '"medio": true');
    jsonString = jsonString.replace(/True/g, 'true').replace(/False/g, 'false');
    jsonString = jsonString.replace(/None/g, 'null');


    try {
      return JSON.parse(jsonString);
    } catch (error) {
      console.error('Erro ao fazer parse da string JSON:', error);
      return null;
    }
  };

  handleNextPageEscola = () => {
    const nextPage = this.state.currentPageEscola + 1;

    this.setState({ currentPageEscola: nextPage }, () => {
      this.fetchDataEscola();
    });
  };

  handleRegionChange = (event) => {
    const selectedRegion = event.target.value;
    window.location.href = `/report-plan-regional/${selectedRegion}`;
  };

  downloadExcel = () => {
    const {
      dataTotal,
      dataEscolaTotal,
      dataPeriodoTotal,
      dataComponenteTotal,
      userUso,
      dataDr
    } = this.state;
    const workbook = XLSX.utils.book_new();

    if (dataDr) {
      let jsonArray = [];

      dataDr.map((d) => {
        const jsonFormated = {
          'Nome DRE': d.dr_nome,
          'Quantidade de Planos de Aprendizagem': d.quantidade_planos_aula,
          'Linguagens': d.linguagens || '',
          'Matemática': d.matematica || '',
          'Professor': d.professor || '',
          'Coordenador': d.coordenador || ''
        };
        jsonArray.push(jsonFormated);
      });

      const title = "Visão por Diretoria Regional"

      const worksheet = XLSX.utils.json_to_sheet(jsonArray);
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        title
      );
    }

    if (dataEscolaTotal) {
      let jsonArray = [];
      dataEscolaTotal.map((d) => {
        const jsonFormated = {
          'ID Escola': d.escola_id,
          'Nome Escola': d.escola_nome,
          'Quantidade de planos de aula': d.quantidade_planos_aula
        };
        jsonArray.push(jsonFormated);
      });

      const worksheet = XLSX.utils.json_to_sheet(jsonArray);
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        'Visão por Unidade Escolar'
      );
    }

    if (dataPeriodoTotal) {
      let jsonArray = [];
      dataPeriodoTotal.map((d) => {
        const jsonFormated = {
          'ID Período': d.periodo_id,
          'Descrição Período': d.periodo_nome,
          'Quantidade de Usos': d.quantidade_usos
        };
        jsonArray.push(jsonFormated);
      });
      const worksheet = XLSX.utils.json_to_sheet(jsonArray);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Visão por Período');
    }

    if (dataTotal) {
      let jsonArray = [];
      dataTotal.map((d) => {
        if (d.habilidade_codigo) {
          const jsonFormated = {
            'ID Habilidade': d.habilidade_id,
            'Código Habilidade': d.habilidade_codigo,
            'Nome Habilidade': d.habilidade_nome,
            'Quantidade de Usos': d.quantidade_usos
          };
          jsonArray.push(jsonFormated);
        }
      });
      const worksheet = XLSX.utils.json_to_sheet(jsonArray);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Visão por Habilidade');
    }

    if (userUso) {
      let jsonArray = [];
      userUso.map((d) => {
        const jsonFormated = {
          'Nome': d.nome,
          'Email': d.email,
          'Quantidade de Planos de Aula': d.quantidade_planos_aula,
          'DRE': d.dre.nome,
          'CD Escola': d.escola.codigo,
          'Nome Escola': d.escola.nome,
        };
        jsonArray.push(jsonFormated);
      });

      const worksheet = XLSX.utils.json_to_sheet(jsonArray);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Visão por Usuário');
    }


    XLSX.writeFile(workbook, `Relatório de Plano de Aula.xlsx`);
  };

  render() {
    const handleConvertToPDF = async () => {
      window.location.href = `/personal-report/impressao`;
    };

    const legendaDre = 'Diretorias';

    return (
      <>
        <Form style={{ marginLeft: '5rem' }}>
          <div
            class="container"
            style={{
              border: '1px solid #d6d6d6',
              backgroundColor: 'white',
              borderRadius: '40px',
              padding: '2%',
              marginTop: '2rem'
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{
                  height: '56px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  background: `${this.props.theme.primary}38`,
                  padding: '8px 24px 8px 24px',
                  borderRadius: '20px',
                  marginBottom: '1rem'
                }}
              >
                <button
                  style={{
                    margin: '0',
                    color: `${!this.state.isLoadingdr ? this.props.theme.primary : this.props.theme.primary + '80'}`,
                    fontWeight: '700',
                    fontSize: '16px',
                    background: 'none',
                    border: 'none',
                    fontFamily: 'Public Sans'
                  }}
                  onClick={() => this.downloadExcel()}
                  disabled={this.state.isLoadingdr}
                >
                  <DescriptionIcon
                    style={{ fontSize: '20px', marginRight: '10px', fontFamily: 'Public Sans', marginBottom: '3px' }}
                  />
                  Baixar Excel
                </button>

                <p
                  style={{
                    margin: '0 20px',
                    color: `${this.props.theme.primary}`
                  }}
                >
                  |
                </p>

                <button
                  style={{
                    margin: '0',
                    color: `${this.props.theme.primary}`,
                    fontWeight: '700',
                    fontSize: '16px',
                    background: 'none',
                    border: 'none',
                    fontFamily: 'Public Sans'
                  }}
                  onClick={() => handleConvertToPDF()}
                >
                  <PictureAsPdfIcon
                    style={{ fontSize: '20px', marginRight: '10px' }}
                  />
                  Baixar PDF
                </button>
              </Grid>


              <Grid item container xs={12} spacing={0} id={'title'}>
                <Grid item container xs={12} spacing={0}>
                  <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
                    <label
                      style={{
                        fontFamily: 'Public Sans',
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#4A4F58',

                      }}
                    >
                      Relatório de Planos de Aprendizagem
                    </label>
                    <label
                      style={{
                        fontFamily: 'Public Sans',
                        fontSize: '16px',
                        fontWeight: '400',
                        color: '#727780',
                      }}
                    >
                      {this.state.dataCount} Planos de Aprendizagem gerados
                    </label>
                  </Grid>

                  <Grid item xs={12}>
                    <hr
                      style={{
                        width: '100%',
                        height: '1px',
                        background: 'rgb(190, 190, 190)'
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginTop: '.7rem', background: 'none' }}
                  id="graphic1"
                >
                  <p style={{ fontFamily: 'Public Sans', fontWeight: '600', fontSize: '18px', color: '#262930' }}>Comparativo de Planos de Aprendizagem gerados entre {legendaDre} Regionais (REDE)</p>
                  {this.state.isLoadingdr ? (
                    <Loading />
                  ) : (
                    this.state.fetchDonedr &&
                    <SimpleBarChart
                      data={this.state.data}
                      dataDr={this.state.dataDr}
                      fontFamily="Public Sans"
                    />
                  )}
                  {this.state.isLoadingtb ? (
                    <Loading />
                  ) : (
                    this.state.fetchDonetb &&
                    <SimpleTable dados={this.state.dataEscola} />
                  )}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: '20px'
                    }}
                  >
                    <button
                      style={{
                        backgroundColor: 'transparent',
                        color: '#626262',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        margin: '0 10px',
                        cursor: 'pointer',
                        fontSize: '14px'
                      }}
                      onClick={this.handlePrevPageEscola}
                      disabled={this.state.currentPageEscola === 1}
                    >
                      &lt;
                    </button>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#333',
                        fontFamily: 'Public Sans'
                      }}
                    >
                      Página {this.state.currentPageEscola} de{' '}
                      {this.state.totalPagesEscola}
                    </span>
                    <button
                      style={{
                        backgroundColor: 'transparent',
                        color: '#626262',
                        border: 'none',
                        borderRadius: '5px',
                        padding: '10px 20px',
                        margin: '0 10px',
                        cursor: 'pointer',
                        fontSize: '14px'
                      }}
                      onClick={this.handleNextPageEscola}
                      disabled={
                        this.state.currentPageEscola === this.state.totalPagesEscola
                      }
                    >
                      &gt;
                    </button>
                  </div>
                  {this.state.isLoading ? (
                    <Loading />
                  ) : (
                    this.state.fetchDone &&
                    <BarChartHorizontal
                      dataPeriodoGeral={this.state.dataPeriodoGeral}
                      fontFamily="Public Sans"
                    />
                  )}
                  {/* {this.state.isLoadingdc ? (
                    <Loading />
                  ) : ( */}
                    {/* this.state.fetchDonedc && */}
                    <SkillsList
                      isLoading={this.state.isLoadingdc}
                      tabValue={this.state.tabValue}
                      handleTabValue={this.handleTabValue}
                      data={this.state.data}
                      dataEscola={this.state.dataEscola}
                      fetch={this.fetchDataHabilidade}
                      dataPeriodo={this.state.dataPeriodo}
                      dataComponente={this.state.dataComponente}
                      dataMetodologia={this.state.dataMetodologia}
                      fetchPeriodo={this.fetchDataPeriodo}
                      fetchComponente={this.fetchDataComponente}
                      fetchMetodologia={this.fetchDataMetodologia}
                      className="expanded"
                    />
                  {/* )} */}
                  <Grid item xs={12}>
                    <hr
                    // style={{
                    //   width: '100%',
                    //   height: '1px',
                    //   background: 'rgb(190, 190, 190)'
                    // }}
                    />
                  </Grid>
                  <Grid
                      item container
                      justifyContent='flex-start' xs={12}
                      style={{
                        marginBottom: '16px',
                      }}
                    >
                      Data de atualizaçāo: {!this.state.updateDate ? '__/__/____' : this.state.updateDate}
                    </Grid>
                </Grid>
              </Grid>
            </Grid>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '20px'
              }}
            >
              <button
                style={{
                  backgroundColor: 'transparent',
                  color: '#626262',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  margin: '0 10px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  position: 'relative',
                  top: '-24px'
                }}
                onClick={this.handlePrevPage}
                disabled={this.state.currentPage === 1}
              >
                &lt;
              </button>
              <span
                style={{
                  fontSize: '14px',
                  color: '#333',
                  fontFamily: 'Public Sans',
                  position: 'relative',
                  top: '-24px'
                }}
              >
                Página {this.state.currentPage} de {this.state.totalPages}
              </span>
              <button
                style={{
                  backgroundColor: 'transparent',
                  color: '#626262',
                  border: 'none',
                  borderRadius: '5px',
                  padding: '10px 20px',
                  margin: '0 10px',
                  cursor: 'pointer',
                  fontSize: '14px',
                  position: 'relative',
                  top: '-24px'
                }}
                onClick={this.handleNextPage}
                disabled={this.state.currentPage === this.state.totalPages}
              >
                &gt;
              </button>
            </div>
          </div>

        </Form>
      </>
    );
  }
}

export default withTheme(ReportDrePage);
